<section class="profile-purchases">
  <div *ngIf="purchases">
    <span class="profile-purchases__content">
      <ul class="profile-purchases__content__list">
        <li *ngFor="let purchase of purchases | slice:0:countShow"
            class="profile-purchases__content__list__item">
          <span (click)="openPreviw(purchase)"
                class="profile-purchases__card" [class.horisontal]="purchase.product.preview.is_horisontal">
            <div class="profile-purchases__card__preview">
              <span *ngIf="purchase.summary_product_count > 1" class="profile-purchases__card__preview__count">
                {{ purchase.summary_product_count }}
              </span>
              <span>
                <img src="{{ purchase.product.preview.url }}" alt="{{ purchase.product.title }}">
              </span>
            </div>
            <div class="profile-purchases__card__info">
              <span class="profile-purchases__card__title">
                {{ purchase.product.title }}
                <span *ngIf="purchase.product.character?.icon_url" class="profile-purchases__card__character">
                  <img src="{{ purchase.product.character?.icon_url }}"
                       alt="{{ purchase.product.character?.title }}"
                       class="profile-purchases__card__character__img">
                </span>
              </span>
              <span class="profile-purchases__card__epoch">
                <span>{{ purchase.product.epoch?.title }}</span>
                <span>
                  <img class="profile-purchases__card__epoch__img"
                       src="{{ purchase.product.epoch?.icon_url }}"
                       alt="{{ purchase.product.epoch?.title }}">
                </span>
              </span>
            </div>
          </span>
        </li>
      </ul>
    </span>
    <span class="profile-purchases__buttons">
      <button [disabled]="countShow >= purchases.length" mat-button (click)="loadNext()">Показать еще: <b>{{ countShow }}</b></button>
      <button [disabled]="countShow >= purchases.length" mat-raised-button (click)="showAll()">Показать все</button>
    </span>
  </div>
</section>
